import React from 'react'
import { FileAudio, FilePdf, Image, Plus } from '@phosphor-icons/react'

const ProjectEmpty = ({
  new_project_content_path,
  new_project_content_path_for_pdf,
  new_project_content_path_for_images,
  new_project_content_path_for_audio,
}) => {

  return (
    <div
      className="flex flex-col gap-4 items-center justify-center py-10 bg-gray-100 rounded-lg shadow-lg">
      <p className="text-lg font-semibold">No contents found in this project.
        Please add some contents to get started.</p>
      <div className="flex gap-2">
        <a href={new_project_content_path} className="btn btn-ghost bg-white btn-xs">
          <Plus weight="fill" color="teal" size={20}/>
          Add Content
        </a>
        <a href={new_project_content_path_for_pdf}
           className="btn btn-ghost bg-white btn-xs">
          <FilePdf weight="fill" color="teal" size={20}/>
          Add PDF
        </a>
        <a href={new_project_content_path_for_images}
           className="btn btn-ghost bg-white btn-xs">
          <Image weight="fill" color="teal" size={20}/>
          Add Images
        </a>
        <a href={new_project_content_path_for_audio}
           className="btn btn-ghost bg-white btn-xs">
          <FileAudio weight="fill" color="teal" size={20}/>
          Add Audio
        </a>
      </div>
    </div>
  )
}

export default ProjectEmpty